import { render, staticRenderFns } from "./BuddhaTypeAdd.vue?vue&type=template&id=434d06da&scoped=true"
import script from "./BuddhaTypeAdd.vue?vue&type=script&lang=js"
export * from "./BuddhaTypeAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434d06da",
  null
  
)

export default component.exports